import { render, staticRenderFns } from "./ArticleTitle.vue?vue&type=template&id=1088f950&"
import script from "./ArticleTitle.vue?vue&type=script&lang=js&"
export * from "./ArticleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports